'use client';

import { TRY_IT, tryItHref } from '../../../config/try-it';

/**
 * "Try it free": the quiet door to the public Try it, beside the header's Book Strategy Call (never instead of it, never lime).
 * Renders nothing while the Try it is off (config/try-it.ts). The address carries the look the visitor is reading in, read from
 * the page at the moment of the click (the theme switch can change it after the page loads).
 */
export function TryItLink({ className, onClick }: { className?: string; onClick?: () => void }) {
  if (!TRY_IT.enabled) return null;
  return (
    <a
      href={tryItHref('dark')}
      className={className}
      onClick={(e) => {
        e.currentTarget.href = tryItHref(document.documentElement.getAttribute('data-skin-mode'));
        onClick?.();
      }}
    >
      {TRY_IT.label}
    </a>
  );
}
